import '../scss/Appspanel.scss';

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { route } from 'preact-router';
import Account from './account';
import Appsview from './Appsview';
import BannerBar from './Bannerbar';
import SoftKeyStore from 'soft-key-store';
import OptionMenu from 'react-option-menu';
import { deviceUtils } from './device-utils';
import { PATH } from './constant';

class Appspanel extends Component {
  state = {
    focusTarget: 'apps-view',
    optionMenu: false
  };

  constructor() {
    super();
    this.bannerQuantity = 3;
    this.initialized = false;
    this.refs = {};
    this.isBannerEnable = window.deviceInfos.get('store.banner.enable');
  }

  handleKeydown(e) {
    switch (e.key) {
      case 'Enter':
        var target = e.target;
        this.handleEnter(target);
        break;
      case 'SoftRight':
        this.showOptionMenu();
        break;
      default:
        break;
    }
  }

  showOptionMenu() {
    const urls = {
      'privacy-policy': 'https://www.kaiostech.com/privacy-policy/',
      'terms-and-services':
        'https://www.kaiostech.com/kaistore-terms-of-service/',
      'need-help': 'https://support.kaiostech.com/support/tickets/new'
    };
    let config = [];

    // If settings is true. (Means supported.)
    if (deviceUtils.featureset.settingsPanelSupported) {
      config = [
        {
          id: Account.version ? 'settings-and-account' : 'settings',
          callback: () => {
            route(PATH.SETTING.URL());
          }
        }
      ];
    }

    for (let item in urls) {
      config.push({
        id: item,
        callback: () => {
          window.open(urls[item]);
        }
      });
    }

    this.setState({ optionMenu: true }, () => {
      this.menu.show({ options: config });
      this.menu.on('closed', () => {
        this.setState({ optionMenu: false });
        this._focus();
      });
    });
  }

  handleEnter(target) {
    const { id, appOrder } = target.dataset;
    if (!id) {
      return;
    }
    route(PATH.PAGE.URL({ id: id, appOrder: parseInt(appOrder, 10) }));
  }

  _updateSoftKey(option) {
    if (!option) {
      return;
    }
    SoftKeyStore.register(option, ReactDOM.findDOMNode(this));
  }

  _focus() {
    var activateElement = this.state.focusTarget;
    var focusElement = ReactDOM.findDOMNode(this.refs[activateElement]);
    var option = {
      left: '',
      center: 'select',
      right: 'options'
    };

    if (focusElement) {
      focusElement.focus();
      this._updateSoftKey(option);

      if (!this.initialized) {
        this.initialized = true;
      }
    }
  }

  activePanel(panel) {
    if (typeof panel === undefined) {
      return;
    }
    this.setState({ focusTarget: panel }, () => this._focus());
  }

  componentDidMount() {
    this.element.addEventListener('keydown', this.handleKeydown.bind(this));
    this._focus();
    this.props.ensureDialogDisplay();
  }

  bannerBlur = () => this.activePanel('apps-view');

  render() {
    return (
      <div
        className="Appspanel"
        tabIndex="1"
        ref={element => {
          this.element = element;
        }}
      >
        {this.isBannerEnable && (
          <BannerBar
            data-id="promotion-bar"
            ref={banner => {
              this.refs['banner'] = banner;
            }}
            blur={this.bannerBlur}
            itemNum={this.bannerQuantity}
          />
        )}
        <Appsview
          ref={appsview => {
            this.refs['apps-view'] = appsview;
          }}
        />
        <div
          id="options-root"
          className={this.state.optionMenu ? '' : 'hidden'}
        >
          <OptionMenu
            ref={element => {
              this.menu = element;
            }}
          />
        </div>
      </div>
    );
  }
}

export default Appspanel;



/** WEBPACK FOOTER **
 ** ./src/Appspanel.js
 **/